import { clientEnv } from "@/env/client";
import { adminClient, usernameClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

// Use window.location.origin in production for proper API URL resolution
const getBaseURL = () => {
  if (typeof window !== 'undefined' && clientEnv.NODE_ENV === 'production') {
    return window.location.origin;
  }
  return clientEnv.NEXT_PUBLIC_APP_URL;
};

export const authClient = createAuthClient({
  baseURL: getBaseURL(),
  plugins: [adminClient(), usernameClient()],
});

export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 128;
